import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/NewButton';

type UnsavedChangesDialogProps = {
  open: boolean;
  isSaving: boolean;
  onSave: () => void;
  onDiscard: () => void;
  onCancel: () => void;
};

export const UnsavedChangesDialog = ({ open, isSaving, onSave, onDiscard, onCancel }: UnsavedChangesDialogProps) => (
  <Dialog open={open} onOpenChange={(isOpen) => { if (!isOpen) onCancel(); }}>
    <DialogContent>
      <DialogHeader>
        <DialogTitle>Unsaved changes</DialogTitle>
        <DialogDescription>
          You have unsaved changes that will be lost. Are you sure you want to leave?
        </DialogDescription>
      </DialogHeader>
      <DialogFooter>
        <Button variant="outline" onClick={onCancel} disabled={isSaving} text="Stay on page" />
        <Button variant="outline" onClick={onSave} loading={isSaving} text="Save changes" />
        <Button variant="destructive" onClick={onDiscard} disabled={isSaving} text="Discard changes" />
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
